import React from 'react';
import ReactDOM from 'react-dom';
import {throttle} from 'lodash'
import App from './App';
import './index.css';
import {default as parentReducer} from './components/parent/parent';
import {default as childReducer} from './components/child/child';
import {saveState, loadState} from './localStorage';

import thunkMiddleware from 'redux-thunk';
import {createLogger} from 'redux-logger'

import createBrowserHistory from 'history/createBrowserHistory'
import {ConnectedRouter, routerReducer, routerMiddleware as routerMiddlewareCreator} from 'react-router-redux'

import {Provider} from "react-redux";
import {createStore, combineReducers, applyMiddleware, compose} from 'redux';
import {reducer as formReducer} from 'redux-form';
import {default as mainReducer, viewportWidthChanged} from './main';

const history = createBrowserHistory();

const persistedState = loadState();
const loggerMiddleware = createLogger();
const routerMiddleware = routerMiddlewareCreator(history);

const reducers = {
  // ... your other reducers here ...
  form: formReducer,     // <---- Mounted at 'form'
  parent: parentReducer,
  children: childReducer,
  main: mainReducer,
  router: routerReducer,
};

const reducer = combineReducers(reducers);
const store = createStore(
  reducer,
  persistedState,
  compose(
    applyMiddleware(
      thunkMiddleware,
      loggerMiddleware,
      routerMiddleware,
    ),
    window.devToolsExtension ? window.devToolsExtension() : f => f
  )
);

store.subscribe(throttle(() => {
  saveState(store.getState());
}), 500);

const addEvent = function(object, type, callback) {
  if (object == null || typeof(object) === 'undefined') return;
  if (object.addEventListener) {
    object.addEventListener(type, callback, false);
  } else if (object.attachEvent) {
    object.attachEvent("on" + type, callback);
  } else {
    object["on"+type] = callback;
  }
};

window && addEvent(window, "resize", () => { store.dispatch(viewportWidthChanged(document.body.clientWidth)) });
store.dispatch(viewportWidthChanged(document.body.clientWidth));

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js